import React from 'react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import CallsDetailOverviewWidget from '@/components/widgets/call-overview/CallsDetailOverviewWidget';
import { CallsOverviewTableColumns } from '@/enums/call-overvew-column';
import { usePreventSpaceKey } from '@/hooks/usePreventSpaceKey';
import { SLABadge } from './SLABadge';

interface SLAModalProps {
  isOpen: boolean;
  onClose: () => void;
  dateParams?: {
    startDate: string;
    endDate: string;
    previousStartDate: string;
    previousEndDate: string;
    queueMicrosoftIds?: string[] | null;
    agentMicrosoftIds?: string[] | null;
    groupIds?: number[] | null;
  };
  callIds?: string[];
  totalSLACalls?: number;
  agentName?: string;
  queueName?: string;
}

export const SLAModal: React.FC<SLAModalProps> = ({
  isOpen,
  onClose,
  dateParams,
  callIds = [],
  totalSLACalls = 0,
  agentName,
  queueName,
}) => {
  // Prevent space key from triggering default behavior
  usePreventSpaceKey(isOpen);

  const slaCallCount = callIds.length;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-[95vw] max-h-[90vh] overflow-auto p-0"
        closeClassName="z-50"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {dateParams ? (
          <CallsDetailOverviewWidget
            callDirectionTypes={null}
            dateParams={dateParams}
            limit={10}
            callMicrosoftIds={callIds}
            customColumns={[
              { title: "Start Time", key: "startTime", minWidth: 120, maxWidth: 150 },
              { title: "Caller", key: "caller", minWidth: 100, maxWidth: 130 },
              { title: "Waiting time", key: "waitingDuration", minWidth: 100, maxWidth: 120 },
              { title: "Call duration", key: "callDuration", minWidth: 100, maxWidth: 120 },
              { title: "Voicemail", key: "voicemail", minWidth: 90, maxWidth: 110 }
            ]}
            exportHiddenColumns={[
              CallsOverviewTableColumns.CALL_STATUS,
              CallsOverviewTableColumns.RECIPIENT
            ]}
            exportButtonClassName="mr-10"
            hideTooltips={true}
            agentName={agentName}
            queueName={queueName}
            customBadge={
              <SLABadge
                agentName={agentName}
                queueName={queueName}
                slaCallCount={slaCallCount}
                totalSLACalls={totalSLACalls}
              />
            }
          // csvOnlyColumns={[]}
          />
        ) : (
          <div className="text-sm text-muted-foreground py-4">
            No date parameters provided
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

